/**
 * 상세 하단 CTA 스타일 — 예전 2.0 하단 CTA 의 껍데기와 같은 값.
 * @description 폰 · 태블릿은 화면 바닥에 고정된 바(위쪽 경계선 + 그림자), 데스크톱은 곁 카드의 맨 아래에
 *   그대로 앉는다. 경계선과 그림자는 한 선언으로 — `shadow-` 를 두 번 쓰면 뒤엣것만 남는다.
 */
export const collabV3CtaStyles = {
  shell: [
    "fixed inset-x-0 bottom-0 z-10 flex flex-col gap-[var(--fw-space-gap-xs)]",
    "px-[var(--fw-space-inset-lg)] py-[var(--fw-space-inset-sm)]",
    "bg-[var(--fw-color-surface-neutral-primary)]",
    "shadow-[inset_0_var(--fw-border-sm)_0_var(--fw-color-border-subtle),0_-4px_12px_var(--fw-color-effect-shadow)]",
    "desktop:static desktop:p-0 desktop:bg-transparent desktop:shadow-none",
  ].join(" "),
  notice:
    "fw-h4 py-[var(--fw-space-inset-xs)] text-[var(--fw-color-content-neutral-secondary)]",
};
